exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-border-box-4{position:relative;width:100%;height:100%}.dv-border-box-4 .dv-reverse{transform:rotate(180deg)}.dv-border-box-4 .dv-border-svg-container{position:absolute;width:100%;height:100%;top:0;left:0}.dv-border-box-4 .dv-border-svg-container>polyline{fill:none}.dv-border-box-4 .sw1{stroke-width:1}.dv-border-box-4 .sw3{stroke-width:3px;stroke-linecap:round}.dv-border-box-4 .dv-bb4-line-1,.dv-border-box-4 .dv-bb4-line-2{stroke-width:1}.dv-border-box-4 .dv-bb4-line-3,.dv-border-box-4 .dv-bb4-line-4{stroke-width:3px;stroke-linecap:round}.dv-border-box-4 .dv-bb4-line-5,.dv-border-box-4 .dv-bb4-line-6,.dv-border-box-4 .dv-bb4-line-7{stroke-width:1}.dv-border-box-4 .dv-bb4-line-8,.dv-border-box-4 .dv-bb4-line-9{stroke-width:3px;stroke-linecap:round}.dv-border-box-4 .dv-bb4-line-9{stroke-dasharray:100 250}.dv-border-box-4 .dv-bb4-line-10{stroke-width:1;stroke-dasharray:80 270}.dv-border-box-4 .border-box-content{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/borderBox4/src/main.css
// module id = 1075
// module chunks = 45